import axios from 'axios';
import { getApiUrl, parseMgkResponse } from '@/config/api';

const BASE = '/api/SatCatalogo';

function unwrapList(response) {
  const data = response.data?.OData || response.data?.odata || response.data || {};
  return {
    items: data.items || data.Items || [],
    total: data.total || data.Total || 0,
    page: data.page || data.Page || 1,
    pageSize: data.pageSize || data.PageSize || 25
  };
}

export default {
  async definiciones() {
    const response = await axios.get(getApiUrl(`${BASE}/definiciones`));
    return response.data?.OData || [];
  },

  async definicion(catalogo) {
    const response = await axios.get(getApiUrl(`${BASE}/definicion/${encodeURIComponent(catalogo)}`));
    return response.data?.OData || null;
  },

  async listar(filtro = {}) {
    const response = await axios.post(getApiUrl(`${BASE}/listar`), filtro);
    return unwrapList(response);
  },

  async guardar(payload) {
    const response = await axios.post(getApiUrl(`${BASE}/guardar`), payload);
    return parseMgkResponse(response);
  },

  async borrar(payload) {
    const response = await axios.post(getApiUrl(`${BASE}/borrar`), payload);
    return parseMgkResponse(response);
  },

  async copiarGlobalAEmpresa(payload) {
    const response = await axios.post(getApiUrl(`${BASE}/copiar-global-a-empresa`), payload);
    return parseMgkResponse(response);
  }
};
